<template>
    <div class="row content-head bg-col-1">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 ">
          <label for="colFormLabel" class="col-form-label">Dealer Role</label>
          <v-select
              placeholder="Select Role"
              v-model="dealerRole"
              :options="companyRules"
              label="name"
              :reduce="name => name.value"
          />
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="mb-1">
          <label for="d-search" class="col-form-label">Dealer/ISC Staff Id</label>
          <div class="dealer-input-wrapper">
            <input
                placeholder="Dealer/ISC Staff Id"
                aria-label="Dealer/ISC Id..."
                @keydown.enter="getDealerIdByStaffId"
                @input="showDealerSuggestions = true"
                @focus="showDealerSuggestions = true"
                @blur="showDealerSuggestions = false"
                type="text" v-model="dealerIscId"
                class="form-control"
                autocomplete="off"
            />
            <small style="color:#000">Press <kbd style="color:#000;background:#eee;border:1px solid #999;border-radius:3px;padding:0 4px">Enter</kbd> to find by serial no</small>
            <ul v-if="showDealerSuggestions && filteredDealerSuggestions.length"
                class="dealer-suggestions">
              <li v-for="s in filteredDealerSuggestions" :key="s"
                  class="dealer-suggestion-item"
                  @mousedown.prevent="selectDealerSuggestion(s)"> 
                <span class="suggestion-text">{{ s }}</span>
              </li>
            </ul>
          </div>
          <transition name="fade">
            <div>
              <span v-if="dealerIscName" class="fw-bold d-block qcont">Dealer/ISC Staff: {{ dealerIscName }}</span>
              <div>
                 <span v-if="dealerBalanceLoader" class="d-block qcont">
                  <span class="spinner-border spinner-border-sm" role="status"></span>
                 </span>
                 <span v-else-if="dealerBalance !== null" class="fw-bold d-block qcont">Balance: {{ dealerBalance }}</span>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="col-12 col-lg-6">
      <div class="row">
        <div class="col-12 col-md-4">
          <label for="colFormLabel" class="col-form-label">Employee Staff</label>
          <input
              type="text" v-model="employeeStaffName"
              class="form-control"
              :readonly="!!dealerRole"
              :placeholder="dealerRole ? '' : 'Type serial no & press Enter'"
              @keydown.enter="!dealerRole ? getContactProfileBySerialNo() : null"
          />
          <small v-if="!dealerRole" style="color:#000">Press <kbd style="color:#000;background:#eee;border:1px solid #999;border-radius:3px;padding:0 4px">Enter</kbd> to find by serial no</small>
          <span v-if="contactProfileFound" class="fw-bold d-block qcont">Name: {{ contactProfileFound }}</span>
        </div>
        <div class="col-12 col-md-4">
          <label for="colFormLabel" class="col-form-label">Date</label>
          <input
              type="date" v-model="formData.date"
              class="form-control"
              :disabled="!canEditDate"
          />
        </div>
        <div class="col-12 col-md-4">
        <label class="form-label mt-1">Ship from (Warehouse)</label>
          <v-select
              placeholder="Select Warehouse Location"
              v-model="locationId"
              :options="locations"
              label="text"
              :reduce="text => text.id"
          />
        </div>
      </div>
      </div>
    </div>
    <div class="row content-head">
        <div class="col-lg-3 d-flex justify-content-center align-items-center bg-col-1">
            <input type="text" class="form-control"
                   v-model="barcodeText"
                   id="chat-search"
                   placeholder="Scan" aria-label="Search..."
                   aria-describedby="chat-search"
                   @keydown.enter="onScanBarcode"
                   ref="productScanField"
            />
        </div>

        <div class="col-lg-7 bg-col-1">
            <div class="row grp-pd">
                <div class="col-12 my-1">
                    <AsyncSelect
                        :api-service="fetchProductList"
                        placeholder="Select Product"
                        v-model="selectedProduct"
                        label="text"
                        :format-label="option => option.text"
                        skip-api-on-open
                        :min-char-to-search="2"
                        ref="productField"
                    />
                </div>
            </div>
        </div>

        <div class="col-lg-2 bg-col-1 d-flex justify-content-center align-items-center">
            <input type="number" class="form-control"
                   v-model="addQty"
                   placeholder="Qty"
                   ref="qtyField"
                   @keydown.enter="onQtyEnter"
            />
        </div>
    </div>
    <div class="row content-head">
        <div class="col-lg-12 bg-col-3">
            <div class="table-container padding-right my-1">
                <table class="table">
                    <thead>
                        <tr>
                            <th>SL</th>
                            <th>Item</th>
                            <th class="text-right">Qty</th>
                            <th class="text-right">Price</th>
                            <th class="text-right">Amount</th>
                            <th></th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
    <div class="row content-border">
        <div class="col-lg-12 content-height bg-col-3">
            <div class="pos-right">
                <div class="pos-scroll">
                    <div class="table-container table-scroll group-list">
                        <table class="table">
                            <tbody>
                                <tr v-for="(item, index) in data" :key="index">
                                    <th>{{ index+1 }}</th>
                                    <th class="text-overflow">{{ item.name }}</th>
                                    <th class="text-right">
                                        <input
                                            v-model="item.quantity"
                                            name="quantity"
                                            type="number"
                                            class="form-control text-right"
                                            @input="changeQty(item.quantity, index)"
                                        /> 
                                    </th>
                                    <th class="text-right">
                                        <input
                                            v-model="item.rate"
                                            name="quantity"
                                            type="number"
                                            class="form-control text-right"
                                        /> 
                                    </th>
                                    <th class="text-right">
                                        <input
                                            type="text"
                                            class="form-control text-right"
                                            :value="item.rate * item.quantity"
                                            readonly
                                        />
                                    </th>
                                    <th>
                                        <span class="cursor-pointer" @click="deleteTableItem(index)">X</span>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <div class="px-1 cal-border">
                        <div class="row mt-1">
                            <div class="col-lg-4">
                                <label class="text-bold">Sub Total</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <input 
                                    class="form-control text-right"
                                    :value="subTotal"
                                    type="number"
                                    readonly
                                >
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-4">
                                <label class="text-bold" for="total_amount">Total VAT</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <input 
                                    class="form-control text-right"
                                    :value="subTotal + totalVat"
                                    type="number"
                                    readonly
                                >
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-4">
                                <label class="text-bold" for="total_amount">Bill Amount</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <input
                                    :value="subTotal"
                                    readonly
                                    name="total_amount"
                                    type="number"
                                    class="form-control text-right"
                                />
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-8">
                                <label class="text-bold">(Less) Round-off / Final Discount</label>
                                <div v-if="discountAmount > 0">
                                    <v-select
                                        placeholder="Select Discount Head"
                                        v-model="formData.discount_head_id"
                                        :options="accountRecHead"
                                        label="name"
                                        :reduce="name => name.id"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <vField
                                            v-model="discountPercent"
                                            name="total_amount"
                                            type="number"
                                            class="form-control text-right"
                                            placeholder="%"
                                            :disabled="!isDiscountAllowed"
                                            :title="!isDiscountAllowed ? 'Discount only allowed when dealer has a negative balance' : ''"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <vField
                                            v-model="discountAmount"
                                            name="total_amount"
                                            type="number"
                                            class="form-control text-right"
                                            @blur="onDiscountAmountBlur"
                                            :disabled="!isDiscountAllowed"
                                            :title="!isDiscountAllowed ? 'Discount only allowed when dealer has a negative balance' : ''"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-4">
                                <label class="text-bold">Net Bill</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <vField
                                    :model-value="grandTotal"
                                    @keyup="setDiscountAmount"
                                    name="total_amount"
                                    type="number"
                                    class="form-control text-right"
                                />
                            </div>
                        </div>

                    </div>
                </div>

                <div @click="openPaymentModal" class="pay-now-btn mb-1">
                    {{ payButtonLabel }}
                </div>
            </div>
        </div>
    </div>

    <PaymentModal
        v-if="isPaymentModal"
        :grandTotal="parseFloat(grandTotal)"
        :rewardPointsAccountHeads="rewardPointsAccountHeads"
        :cashAndBank="cashAndBank"
        :submitLabel="submitButtonLabel"
        :submitLoading="submitLoading"
        @close="isPaymentModal = false"
        @onSubmit="submitData"
    />
</template>

<script setup>
import { ref, reactive, watch, onMounted, computed, inject, provide, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import handlePurchase from '@/services/modules/purchase';
import pdfPrinter from '@/services/utils/pdfPrinter';
import handleBarcode from '@/services/modules/barcode';
import figureFormatter from '@/services/utils/figureFormatter';
import handleCompany from '@/services/modules/company';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import PaymentModal from "@/components/molecule/company/sdm/pos-invoice/PaymentModal.vue";
import handleDropdowns from "@/services/modules/dropdowns";
import handlePurchaseAndSales from "@/services/modules/purchase";
import useInvoiceCalculations from '@/composables/useInvoiceCalculations';
import useDate from "@/services/utils/day";
import handleCompanyContact from "@/services/modules/companyContact";
import handleRole from "@/services/modules/role";
import handleBusinessesLocations from '@/services/modules/businessesLocations'
import useReport from '@/services/modules/dashboard/report.js'

const props = defineProps({
  items: Array,
  contactProfileId: null,
  companyId: null,
  productId: null,
  editBillId: null,
});

const emit = defineEmits(['resetIds', 'onUpdated']);

const store = useStore();
const route = useRoute();
const router = useRouter();
const date = useDate();
const products = ref([]);
const data = ref([]);
const voucher = ref('');
const companyInfo = ref({});
const cashAndBank = ref([]);
const discountAccHead = ref([]);
const accountRecHead = ref([]);
const totalVat = ref(0);
const isPaymentModal = ref(false);
const loader = ref(false);
const selectedProduct = ref(null);
const productScanField = ref(null);
const isFromProductScan = ref(false);
const rewardPointsAccountHeads = ref([]);
const productField = ref(null);
const qtyField = ref(null);
const dealerField = ref(null);
const pendingProduct = ref(null);
const invoiceRes = ref({});
const company = ref({});
const barcodeQuery = ref('');
const barcode = ref('');
const qrcode = ref('');
const customizationPdfFields = ref([]);
const totals = ref({
  subTotalVal: 0,
  totalVatVal: 0,
  totalVal: 0,
})
const dealerRole = ref(null);
const companyRules = ref([])
const dealerIscId = ref(null);
const employeeStaffName = ref(null);
const contactProfileFound = ref(null);
const dealerIscName = ref(null);
const dealerBalance = ref(null);
const dealerBalanceLoader = ref(false);

const dealerIdHistory = ref(JSON.parse(localStorage.getItem('pos_dealer_isc_ids') || '[]'));
const showDealerSuggestions = ref(false);
const filteredDealerSuggestions = computed(() => {
  const q = dealerIscId.value ? String(dealerIscId.value).toLowerCase() : '';
  return dealerIdHistory.value.filter(id => !q || id.toLowerCase().includes(q)).slice(0, 10);
});
const saveDealerIdToHistory = (id) => {
  const normalized = String(id).toLowerCase();
  const updated = [normalized, ...dealerIdHistory.value.filter(i => i !== normalized)].slice(0, 1000);
  localStorage.setItem('pos_dealer_isc_ids', JSON.stringify(updated));
  Object.assign(dealerIdHistory, { value: updated });
};
const selectDealerSuggestion = (val) => {
  dealerIscId.value = val;
  showDealerSuggestions.value = false;
  getDealerIdByStaffId();
};
const locations = ref([]);
const locationId = ref(null);

const {
  subTotal,
  grandTotal,
  discountAmount,
  discountPercent,
  setDiscountAmount,
  resetDiscounts,
} = useInvoiceCalculations(data, totals)

const addQty = ref(null);
const barcodeText = ref(null);

const showError = inject("showError");
const showSuccess = inject("showSuccess");

const { fetchProductDropdownList, fetchDropdownList } = handleDropdowns();
const { fetchSalesBill, ...rest } = handlePurchase();
const { fetchProductList } = handlePurchaseAndSales();
const { exportToPDF } = pdfPrinter();
const { fetchCompanyInfo, fetchActiveCustomizationField } = handleCompany();
const { formatDate } = figureFormatter();
const { fetchBarcode } = handleBarcode();
const { fetchContactProfileBySerialNo } = handleCompanyContact();
const { fetchCompanyDefaultRoles, checkUserHasRoles } = handleRole();
const { fetchBusinessLocationsList } = handleBusinessesLocations()

const canEditDate = ref(false);
const { fetchCustomerClosingBalance } = useReport()

const editingBillId = ref(null);
const submitLoading = ref(false);
const isEditMode = computed(() => !! editingBillId.value);
const payButtonLabel = computed(() => {
  if (isEditMode.value) return 'Update';
  return 'Pay Now';
});
const submitButtonLabel = computed(() => {
  if (isEditMode.value) return 'UPDATE';
  return 'PRINT';
});

const formData = reactive({
  company_id: null,
  contact_profile_id: null,
  referrer_id: null,
  account_head_id: null,
  liability_head_id: null,
  mop_account_head_id: null,
  business_id: null,
  project_id: null,
  cost_centre_id: null,
  location_id: null,
  status: 'active',
  bill_number: '',
  date: date.currentDate(),
  has_item_detail: true,
  description: '',
  order_number: null,
  sales_person_id: null,
  commission_percent: null,
  lc_number: null,
  discount_head_id: null,
  vat_amount: 0,
  advance_amount: 0,
  advance_receipts: [],
  sale_type: 'pos_invoice',
  receipt_type: 'pos_invoice',
  receipt_reference: '',
  item_details: [{
    product_id: null,
    name: '',
    description: '',
    quantity: 1,
    rate: 0,
    discount_percent: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
  }]
});

provide('formData', formData);

const getDealerIdByStaffId = () => {
  showDealerSuggestions.value = false;
  if (!dealerRole.value){
    showError("Please select Dealer Role")
    return
  }
  dealerBalance.value = null;
  dealerIscName.value = null;
  formData.referrer_id = null;
  employeeStaffName.value = null;
  contactProfileFound.value = null;

  let companyQuery = `?company_id=${route.params.companyId}&roles=`+dealerRole.value
  companyQuery += '&serial_no='+dealerIscId.value;
  fetchContactProfileBySerialNo(companyQuery).then(async res => {
    if (!res.status) {
      return showError(res.message)
    }
    formData.referrer_id = res.data.id;
    dealerIscName.value = res.data.full_name;
    saveDealerIdToHistory(dealerIscId.value);
    formData.contact_profile_id = res.data.contact_owner_id;
    employeeStaffName.value = res.data.contact_owner_name;

    if (!res.data.contact_owner_id) return;

    dealerBalanceLoader.value = true;
    try {
      const query = `?company_id=${props.companyId}&contact_profile_id=${res.data.contact_owner_id}`;
      const balanceRes = await fetchCustomerClosingBalance(query);

      if (balanceRes.status) {
        dealerBalance.value = balanceRes.data;
      }
    } finally {
      dealerBalanceLoader.value = false;
    }
  })
}

const getContactProfileBySerialNo = () => {
  if (!employeeStaffName.value) return;
  formData.contact_profile_id = null;
  dealerBalance.value = null;
  dealerIscName.value = null;
  contactProfileFound.value = null;
  formData.referrer_id = null;

  const companyQuery = `?company_id=${route.params.companyId}&serial_no=${employeeStaffName.value}&roles=employee`;
  fetchContactProfileBySerialNo(companyQuery).then(res => {
    if (!res.status) {
      return showError(res.message)
    }
    formData.contact_profile_id = res.data.id;
    contactProfileFound.value = res.data.full_name;
  })
}

const setEditTableItems = (bill) => {
  if (! bill.general || bill.general.length < 1) {
    data.value = [];
    return;
  }

  data.value = bill.general.map((item) => {
    const productName = item.product ? item.product.name : '';
    return {
      id: item.id,
      product_id: item.product_id,
      name: productName,
      description: item.description || '',
      quantity: Number(item.quantity) || 0,
      rate: Number(item.rate) || 0,
      discount: 0,
      vat: Number(item.vat) || 0,
      sub_total: 0,
      discount_amount: Number(item.discount_amount) || 0,
      discount_percent: Number(item.discount_percent) || 0,
      vat_amount: Number(item.vat_amount) || 0,
      total: 0,
      amount: (Number(item.rate) || 0) * (Number(item.quantity) || 0),
      total_amount: (Number(item.rate) || 0) * (Number(item.quantity) || 0),
      is_edit: false,
      stock_in_hand: null,
      product: { name: productName },
    }
  });
}

const setEditReceiptInfo = (bill) => {
  const receiptGenerals = bill.receipt_generals;
  if (! receiptGenerals || receiptGenerals.length < 1) return;

  const receiptMaster = receiptGenerals[0].receipt_master;
  if (! receiptMaster) return;

  formData.receipt_master_id = receiptMaster.id;
  formData.money_receipt_no = receiptMaster.voucher_no;
  formData.receipt_reference = receiptMaster.receipt_reference;
  formData.payment = Number(receiptMaster.total_paid_amount) || 0;
  if (receiptMaster.account_head_id) {
    formData.mop_account_head_id = receiptMaster.account_head_id;
  }
}

const setEditDealerInfo = (bill) => {
  formData.referrer_id = bill.referrer_id;
  dealerIscName.value = bill.referrer_name;
  dealerIscId.value = bill.referrer_serial_no;
  if (! bill.contact) return;
  employeeStaffName.value = bill.contact.name;
  contactProfileFound.value = bill.contact.name;
}

const loadBillForEdit = async (id) => {
  if (! id) return;

  const companyQuery = `?company_id=${props.companyId}`;
  loader.value = true;

  try {
    const res = await fetchSalesBill(id, companyQuery);

    if (! res.status) {
      showError('Unable to load the bill for edit');
      return;
    }

    const bill = res.data;
    editingBillId.value = id;

    formData.contact_profile_id = bill.contact_profile_id;
    formData.bill_number = bill.bill_number;
    formData.date = bill.date;
    formData.description = bill.description || '';
    formData.order_number = bill.order_number;
    formData.status = bill.status;
    if (bill.location_id) locationId.value = bill.location_id;
    if (bill.account_head_id) formData.account_head_id = bill.account_head_id;

    setEditTableItems(bill);
    setEditDealerInfo(bill);
    setEditReceiptInfo(bill);
    setDiscountAmount(Number(bill.round_up_discount) || 0);
  } catch (e) {
    showError('Unable to load the bill for edit');
  } finally {
    loader.value = false;
  }
}

watch(() => props.editBillId, (newId) => {
  if (! newId) return;
  loadBillForEdit(newId);
});

onMounted(async () => {
    await getLocations();
    await getAccountData();
    await checkDatePermission();
    await loadBillForEdit(props.editBillId);
    await nextTick(() => {
      if (productScanField.value) {
        productScanField.value.focus();
      }
    });
});

const checkDatePermission = async () => {
    const DATE_ALLOWED_ROLES = ['software_admin'];
    const rolesQuery = DATE_ALLOWED_ROLES.map(r => `&roles[]=${r}`).join('');
    const query = `?company_id=${props.companyId}${rolesQuery}`;
    const res = await checkUserHasRoles(query);
    if (res.status){
      canEditDate.value = res.data.has_role;
    }
};

const onQtyEnter = async () => {
    if (!pendingProduct.value) {
        if (productScanField.value) productScanField.value.focus();
        return;
    }

    const newProduct = pendingProduct.value;
    const qty = addQty.value || 1;

    if (newProduct.product_type === "services") {
        addServiceItem(newProduct, qty);
    }

    let res = null;
    if (newProduct.product_type !== "services") {
        const query = `?company_id=${props.companyId}&location_id=${locationId.value}`;
        res = await rest.fetchProductById(newProduct.id, query);
    }

    if (res && !res.status) showError('Product not found');
    if (res && res.status) addItem(res.data, qty);

    pendingProduct.value = null;
    selectedProduct.value = null;
    if (productField.value) productField.value.clear();
    addQty.value = null;
    barcodeText.value = null;

    if (productScanField.value) {
        productScanField.value.focus();
    }
};

const onScanBarcode = async () => {
  if (!barcodeText.value) return;

  const companyQuery = `?company_id=${props.companyId}`;
  const query = `${companyQuery}&barcode_sku=${barcodeText.value}&location_id=${locationId.value}&is_service=1&with_desc_stock=1`;

  try {
    loader.value = true;

    const response = await fetchProductDropdownList(query);

    if (!response.status || response.data.length < 1) {
      showError('No product found with this barcode');
      barcodeText.value = null;
      loader.value = false
      return;
    }

    let foundProduct = response.data[0];
    foundProduct.name = foundProduct.text;
    foundProduct.sales_price = foundProduct.description ? foundProduct.description.sales_price : 0;

    barcodeText.value = null;
    selectedProduct.value = foundProduct;
  } catch (e) {
    showError('Failed to fetch product by barcode');
  } finally {
    loader.value = false;
  }
};

const openPaymentModal = () => {
    isPaymentModal.value = true;
}

async function submitData() {
  if (isEditMode.value) {
    await updateData();
    return;
  }

  organizeData();
  const handler = handlePurchase();
  const copyFormData = { ...formData };
  copyFormData.item_details = data.value;
  copyFormData.sale_master_receipt = true;
  copyFormData.is_sale_allocation = true;

  submitLoading.value = true;

  try {
    const res = await handler.storeBillPayment(copyFormData);

    if(! res.status ) {
        showError(res.message);
        return;
    }

    showSuccess(res.message)
    goToPrint(res.data.id);
    resetForm();
    isPaymentModal.value = false;
  } catch (e) {
    showError('Something went wrong');
  } finally {
    submitLoading.value = false;
  }
}

async function updateData() {
  organizeData();
  const copyFormData = { ...formData };
  copyFormData.item_details = data.value;
  copyFormData.sale_master_receipt = true;
  copyFormData.is_sale_allocation = true;

  submitLoading.value = true;

  try {
    const res = await rest.updateSalesBill(editingBillId.value, copyFormData);

    if(! res.status ) {
        showError(res.message);
        return;
    }

    showSuccess(res.message)
    goToPrint(editingBillId.value);
    editingBillId.value = null;
    resetForm();
    isPaymentModal.value = false;
    emit('onUpdated');
  } catch (e) {
    showError('Something went wrong');
  } finally {
    submitLoading.value = false;
  }
}

const goToPrint = (id) => {
  const user = store.state.user.user
  const companyQuery = `?company_id=${props.companyId}`;
  fetchSalesBill(id, companyQuery).then( (res) => {
    if( res ){
      invoiceRes.value = res.data;
      let qrcodeData = JSON.stringify({
        ref_no: invoiceRes.value.bill_number,
        ref_date: invoiceRes.value.date,
        created_by: user.name,
        created_date_time: formatDate(new Date())
      })
      barcodeQuery.value = `?code=${invoiceRes.value.bill_number}&qrcode=${qrcodeData}`;
    }}).then (() => {
    fetchBarcode(barcodeQuery.value).then( (res) => {
      barcode.value = res.barcode;
      qrcode.value = res.qrcode
    }).then( () => {
      exportToPDF(company.value, invoiceRes.value, barcode.value, qrcode.value, user.name, 1, [], false, customizationPdfFields.value)
    })
  }).catch( (e) => {
    console.log("Something went wrong");
  })
}

function organizeData() {
  formData.company_id = props.companyId;
  formData.location_id = locationId.value;
  formData.adjustment_amount = discountAmount.value;
  data.value = data.value.map(item => ({
    ...item,
    total_amount: (Number(item.rate) || 0) * (Number(item.quantity) || 0),
    sale_master_id: editingBillId.value || null,
  }));
}

const getActiveFiledCustomization = async () => {
  const companyQuery = `?company_id=${props.companyId}&customization_type=pdf&type=pos_bill_marketing`;
  const res = await fetchActiveCustomizationField(companyQuery);
  customizationPdfFields.value = res.data;
};

const addServiceItem = (item, quantity = 1) => {
  if (!item) {
    showError('Product not found');
    return;
  }

  let alreadyExist = false;
  let existingIndex = -1;

  data.value.forEach((el, index) => {
    if (el.product_id === item.id) {
      alreadyExist = true;
      existingIndex = index;
    }
  });

  if (alreadyExist) {
    const existingItem = data.value[existingIndex];

    existingItem.quantity += quantity;
    changeQty(existingItem.quantity, existingIndex);
    return;
  }

  const product = { name: item.text };

  const newItem = {
    product_id: item.id,
    name: item.text,
    description: '',
    quantity,
    rate: item.description && item.description.sales_price,
    discount: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    discount_percent: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
    stock_in_hand:null,
    product
  };

  data.value.push(newItem);
}

const addItem = (item, quantity = 1, isBarcode  = false) => {
  if (!item) {
    showError('Product not found');
    return;
  }

  if (item.product_type == 'finished_goods' && item.stock_in_hand !== undefined && item.stock_in_hand <= 0) {
    showError('Stock not available');
    return;
  }

  let alreadyExist = false;
  let existingIndex = -1;

  data.value.forEach((el, index) => {
    if (el.product_id === item.id) {
      alreadyExist = true;
      existingIndex = index;
    }
  });

  if (alreadyExist) {
    const existingItem = data.value[existingIndex];

    if (
      item.product_type == 'finished_goods' &&
      item.stock_in_hand !== undefined &&
      existingItem.quantity + quantity > item.stock_in_hand
    ) {
      showError('Stock limit exceeded');
      return;
    }

    existingItem.quantity += quantity;
    changeQty(existingItem.quantity, existingIndex);
    return;
  }

  const product = { name: item.name };

  const newItem = {
    product_id: item.id,
    name: item.stock_in_hand && !isBarcode
        ? `${item.name} | Stock: ${item.stock_in_hand}`
        : item.name,
    description: '',
    quantity,
    rate: item.sales_price ?? 0,
    discount: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    discount_percent: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
    stock_in_hand: item.stock_in_hand ?? null,
    product
  };

  data.value.push(newItem);
}

function deleteTableItem(index) {
  data.value.splice(index, 1);
}

const changeQty = (quantity, index) => {
  const item = data.value[index];

  if (!Number.isInteger(Number(quantity)) || quantity <= 0) {
    showError('Quantity must be a positive number');
    item.quantity = 1;
    return;
  }

  if (
    item.product_type == 'finished_goods' &&
    item.stock_in_hand !== null &&
    quantity > item.stock_in_hand
  ) {
    showError('Stock limit exceeded');
    item.quantity = item.stock_in_hand;
    return;
  }

  item.amount = item.rate * quantity;
  item.total_amount = item.rate * quantity;
}

const getLocations = async () => {
  const companyQuery = `?company_id=${route.params.companyId}`
  const locationQuery = `${companyQuery}&location_type=fg_warehouse`;
  const res = await fetchBusinessLocationsList(locationQuery);
  if(!res.status) return;
  locations.value = res.data;
  if (locationId.value) return;
  locationId.value = locations.value[0].id;
}

const getAccountData = async () => {
    const dropdownRes = fetchDropdownList(getDropDownQuery());
    let roleQuery = `?company_id=${route.params.companyId}&roles=dealer,isc`;
    const rolesRes = fetchCompanyDefaultRoles(roleQuery)

    await Promise.all([
        dropdownRes.then(async res => {
          if(! res.status) return;

          if(res.data.account_head_list_by_slag.accounts_receivable) {
            accountRecHead.value = res.data.account_head_list_by_slag.accounts_receivable;
            formData.account_head_id = res.data.account_head_list_by_slag.accounts_receivable[0].id;
          }
          const roles = await rolesRes;
          if (roles.data) companyRules.value = roles.data

          if(res.data.account_head_list_by_slag.vat_payable) {
            formData.vat_payable_account_head_id = res.data.account_head_list_by_slag.vat_payable[0].id;
          }

          if(res.data.account_head_list_by_slag.discount_account) {
            discountAccHead.value = res.data.account_head_list_by_slag.discount_account;
          }

          if(res.data.account_head_list_by_slag.cash_and_banks) {
            cashAndBank.value = res.data.account_head_list_by_slag.cash_and_banks;
            formData.mop_account_head_id = cashAndBank.value[0].id;
          }

          if(res.data.account_head_list_by_slag.reward_points) {
            rewardPointsAccountHeads.value = res.data.account_head_list_by_slag.reward_points;
          }
        }),
        fetchCompanyInfo(props.companyId).then(res=> {
          if(res.data) company.value = res.data;
        }),
        getActiveFiledCustomization()
    ]).finally(() => {loader.value=false})
}

const getDropDownQuery = () => {
  let query = `?company_id=${props.companyId}
    &is_account_heads=1
    &slags[]=discount_account
    &slags[]=reward_points
    &slags[]=vat_payable
    &slags[]=accounts_receivable
    &slags[]=cash_and_banks`;
                
  return query;
}

function resetForm() {
  data.value = [];
  editingBillId.value = null;
  discountAmount.value = 0;
  discountPercent.value = 0;
  dealerRole.value = null;
  dealerIscId.value = null;
  employeeStaffName.value = null;
  contactProfileFound.value = null;
  dealerIscName.value = null;
  dealerBalance.value = null;
  dealerBalanceLoader.value = false;
  if (dealerField.value) dealerField.value.clear();
  Object.assign(formData, {
    ...formData,
    company_id: props.companyId,
    contact_profile_id: null,
    liability_head_id: null,
    account_head_id: accountRecHead.value[0].id,
    mop_account_head_id: cashAndBank.value[0].id,
    business_id: null,
    project_id: null,
    cost_centre_id: null,
    location_id: null,
    status: 'active',
    bill_number: '',
    date: date.currentDate(),
    has_item_detail: true,
    description: '',
    order_number: null,
    sales_person_id: null,
    commission_percent: null,
    lc_number: null,
    discount_amount: 0,
    discount_percent: 0,
    discount_head_id: discountAccHead.value[0].id,
    vat_amount: 0,
    payment: 0,
    points_redeemed: 0,
    receipt_master_id: null,
    money_receipt_no: null,
    receipt_reference: '',
    adjustment_amount: 0,
    sale_type: 'pos_invoice',
    receipt_type: 'pos_invoice',
    item_details: [{
      product_id: null,
      name: '',
      description: '',
      quantity: 1,
      rate: 0,
      discount_percent: 0,
      vat: 0,
      sub_total: 0,
      discount_amount: 0,
      vat_amount: 0,
      total: 0,
      is_edit: false,
    }]
  });
  resetDiscounts();
}

watch(selectedProduct, async (newProduct) => {
    if (!newProduct) return;

    pendingProduct.value = newProduct;

    if (qtyField.value) {
        qtyField.value.focus();
        qtyField.value.select();
    }
});

const isDiscountAllowed = computed(() => {
  return dealerBalance.value !== null && dealerBalance.value < 0;
});

const maxAllowedDiscount = computed(() => {
  return isDiscountAllowed.value ? Math.abs(dealerBalance.value) : 0;
});

watch(discountAmount, (newValue) => {
  if (!isDiscountAllowed.value) return;

  const cap = Math.min(maxAllowedDiscount.value, subTotal.value);
  if (newValue > cap) {
    discountAmount.value = cap;
    return;
  }

  if(newValue > 0 && accountRecHead.value.length > 0) {
    formData.discount_head_id = accountRecHead.value[0].id;
    formData.adjustment_amount = discountAmount.value;
  }
})

watch(isDiscountAllowed, (allowed) => {
  if (!allowed) {
    discountAmount.value = 0;
    discountPercent.value = 0;
  }
})

const onDiscountAmountBlur = () => {
  if (!isDiscountAllowed.value) {
    showError('Discount is only allowed when dealer has a negative balance');
    discountAmount.value = 0;
    return;
  }

  const cap = Math.min(maxAllowedDiscount.value, subTotal.value);

  if (discountAmount.value > cap) {
    showError(`Discount amount must be less than or equal to ${cap}`);
    discountAmount.value = 0;
  }
}

watch(dealerRole, () => {
  dealerIscId.value = null;
  if (dealerField.value) dealerField.value.clear();
})

</script>

<style scoped>
.group-list {
    overflow-y: auto;
    overflow-x: hidden;
}
.content-head {
    margin-left: 1px;
    margin-right: 1px;
}
.content-height {
    min-height: 520px;
}

.padding-right {
    padding-right: 3rem;
}

.group-list::-webkit-scrollbar {
    width: 4px;
}

.group-list::-webkit-scrollbar-track {
    background: transparent;
}

.group-list::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 10px;
}

.group-head {
    background: #5286d4;
    color: #fff;
}

.grp-pd {
    padding: 2px 0px;
}

.group-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 12px 14px;
    margin: 8px 2px;
    cursor: pointer;

    display: flex;
    align-items: center;

    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    transition: all 0.2s ease;
}

.group-item:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
    transform: translateY(-1px);
    background: #f3f2f7;
}

.group-item.active {
    background: #7367f0; /* Vuexy primary */
    color: #fff;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 1.4);
}

.group-item.active .head-group {
    color: #fff;
}

.head-group {
    display: block;

    font-size: 24px;
    text-align: center;
    line-height: 80px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.table-scroll {
    min-height: 200px !important;
}

.margin-5 {
    margin-top: 5px;
}

.content-border {
    margin-left: 1px;
    margin-right: 1px;
}
.pay-now-btn {
    background: #7367f0;
    color: #fff;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    cursor: pointer;
    font-size: 20px;
    border-radius: 10px;
    margin:10px;
}

.pos-right {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.pos-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

.cal-border {
    border-top: 3px solid;
}

.bg-col-1 {
    background-color: rgba(115, 103, 240, 0.12);
    padding-right: 0px;
}

.bg-col-2 {
    background-color: rgba(40, 199, 111, 0.12);
}

.bg-col-3 {
    background-color: rgba(255, 159, 67, 0.12);
}

.table {
  table-layout: fixed;
  width: 100%;
}

.table th:nth-child(1),
.table td:nth-child(1) {
  width: 8%;
}

.table th:nth-child(2),
.table td:nth-child(2) {
  width: 45%; /* ITEM → BIG */
}

.table th:nth-child(3),
.table td:nth-child(3),
.table th:nth-child(4),
.table td:nth-child(4),
.table th:nth-child(5),
.table td:nth-child(5) {
  width: 15%; /* Qty, Price, Amount */
}

.table th:nth-child(6),
.table td:nth-child(6) {
  width: 5%; /* delete */
}

/* Dealer suggestion dropdown */
.dealer-input-wrapper {
  position: relative;
}

.dealer-suggestions {
  position: absolute;
  z-index: 999;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  list-style: none;
  margin: 2px 0 0;
  padding: 4px 0;
  background: #fff;
  border: 1px solid #e0daf8;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(115, 103, 240, 0.15);
}

.dealer-suggestions::-webkit-scrollbar {
  width: 4px;
}

.dealer-suggestions::-webkit-scrollbar-track {
  background: transparent;
}

.dealer-suggestions::-webkit-scrollbar-thumb {
  background-color: rgba(115, 103, 240, 0.35);
  border-radius: 10px;
}

.dealer-suggestion-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  font-size: 13px;
  color: #444;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  border-bottom: 1px solid #e8e8e8;
}

.dealer-suggestion-item:last-child {
  border-bottom: none;
}

.dealer-suggestion-item:hover {
  background: rgba(115, 103, 240, 0.1);
  color: #7367f0;
}

.suggestion-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>